// external dependencies
import { ApiResponse, API_SUCCESS_STATUS_CODE } from "@swiggy-private/core-utils";

import { HTTP_METHODS, makeDownstreamApiCall, Response } from "@swiggy-private/checkout-core";

// The API returns a simple success response
export type UpdateBillImagesResponse = Record<string, never>;

export interface UpdateBillImagesParams {
    uploadedFileURLs?: string[];
    clearImages?: boolean;
}

export interface UpdateBillImagesBodyParams {
    uploadedFileURLs?: string[];
}

// constants
export const UPDATE_BILL_IMAGES_URI = "/api/v2/view/updateBillImages";

// API call function
export async function updateBillImagesPublic(
    apiHost: string,
    params: UpdateBillImagesParams,
): Promise<ApiResponse<UpdateBillImagesResponse>> {
    const { clearImages, uploadedFileURLs } = params;

    const searchParams: Record<string, string> = {};
    if (clearImages) {
        searchParams.clearImages = "true";
    }

    const bodyParams: UpdateBillImagesBodyParams = uploadedFileURLs ? { uploadedFileURLs } : {};

    const response = await makeDownstreamApiCall<Response<UpdateBillImagesResponse>>({
        apiHost,
        endpoint: UPDATE_BILL_IMAGES_URI,
        bodyParams: bodyParams as { [key: string]: unknown },
        searchParams,
        options: { method: HTTP_METHODS.POST },
    });

    if (response.statusCode !== API_SUCCESS_STATUS_CODE) {
        throw response;
    } else {
        return response as ApiResponse<UpdateBillImagesResponse>;
    }
}
